// components/GlobalLoaderRoot.js

import React, { useState, useEffect } from 'react';



const ComponentLevelLoader = ({isLoading = false}) => {
     const [showLoader,setShowLoader] = useState(isLoading);

  useEffect(() => {
   // console.log("component level loader is loading");
   // console.log(isLoading); 
    setShowLoader(isLoading);
   
  }, [isLoading]); 

  if (!showLoader) return null; 

  return (
     <div className="global-loader-overlay">
      
      {/* <div className="loader-spinner"></div>  */}
       <img src='/images/loadinggif.gif' /> 
    </div>
  );
};

export default ComponentLevelLoader;
